<template>
    <div class="foot__content">
        <div class="foot">
            <img class="foot__logo" src='https://static.zc0901.com/imola-dci-web-icon-new-1.png' />
            <div class="foot__date">Copyright@2012 NEST AWARD All Rights</div>
            <div class="foot__name">Reserved 版权所有 DCI瓷砖</div>
            <div class="foot__number">苏ICP备20034816号-1 京公网安备11010502030307</div>
            <div class="foot__desc">扫一扫，关注DCI服务号</div>
            <img class="foot__code" src='http://static.zc0901.com/imola-dci-web-icon-wechat.jpg' />
        </div>
    </div>
</template>
<script>


	export default {
		data() {
			return {
				
			}
		},
		computed: {
			
		},
        created(){
            
        },
		mounted() {
		},
		methods: {}
	}
</script>
<style scoped lang="scss">
    .foot__content{
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        background:rgba(19,26,37,1);
    }
    .foot{
    width: 1160px;
    height: 298px;
    background-image: url('https://static.zc0901.com/dci-web-brand-born-bg-bottom.png');
    position: 100%;
    background-size:100% 100%;
    position: relative;
    font-size:18px;
    font-weight:400;
    color:rgba(255,255,255,1);
    line-height:32px;
    text-align: left;
    &__logo{
        width: 130px;
        // height: 90px;
        position: absolute;
        top: 75px;
        left: 0;
    }
    &__date{
        padding-top: 196px;
        box-sizing: border-box;
    }
    &__number{

    }
    &__desc{
        position: absolute;
        bottom: 0;
        right: 0;
    }
    &__code{
        position: absolute;
        bottom: 34px;
        right: 0;
        width: 120px;
        height: 120px;
    }
}
</style>
